import React, {useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {AuditListLoading} from './loading/AuditListLoading'
import AddAudit from './drawer/AddAudit'
import { useAuth } from 'app/modules/auth'
import useAuditContext from 'app/Hooks/useAuditContext'

interface EmptyStateProps {
  type: 'loading' | 'no-results' | 'no-audits'
  showEmptyState: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({type, showEmptyState}) => {
  const [showAddaudit, setShowAddaudit] = useState<boolean>(false)
  const handleCloseAudit = () => setShowAddaudit(false)
  const {currentUser} = useAuth()
  const {currentAuditContext} = useAuditContext()

  const renderContent = () => {
    switch (type) {
      case 'no-results':
        return (
          <div className='m-20'>
            <img src={toAbsoluteUrl('/media/buttons/EmptyState-Search.svg')} alt='' />
            <div className='mt-5 mb-2 fs-5'>
              <span className='text-gray-900 fw-semibold'>No Matching Results</span>
            </div>
            <p className='m-0 text-gray-900 fw-normal'>
              Please try a different search or try removing filters.
            </p>
          </div>
        )
      case 'no-audits':
        return (
          <div className=''>
            <img src={toAbsoluteUrl('/media/buttons/EmptyState-File.svg')} alt='' />
            <div className='mt-5 mb-2 fs-5'>
            <span className='text-gray-900 fw-semibold'>Nothing here</span>
            </div>
            <p className='m-0 text-gray-900 fw-normal'>You currently have no active or upcoming audits.</p>
          </div>
        )
      case 'loading':
      default:
        return showEmptyState ? (
          <div className=''>
            <img src={toAbsoluteUrl('/media/buttons/EmptyState-File.svg')} alt='' />
            <div className='mt-5 mb-2 fs-5'>
              <span className='text-gray-900 fw-semibold'>Nothing here</span>
            </div>
            <p className='m-0 mb-2 text-gray-900 fw-normal'>
            You currently have no active or upcoming audits.
            </p>
            {currentUser?.role !== 'Auditor' && !currentAuditContext && (
            <button
              type='button'
              className=' btn btn-sm btn-light me-4 fs-6'
              onClick={()=>setShowAddaudit(true)}
              style={{
                height: '40px',
                background: '#fff',
                color: '#000',
                border: '1px solid #C5C5C5',
              }}
              disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                className='icon icon-tabler icons-tabler-outline icon-tabler-plus mb-1 me-2'
              >
                <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                <path d='M12 5l0 14' />
                <path d='M5 12l14 0' />
              </svg>
              Add Audit
            </button>
            )}
          </div>
        ) : (
          <AuditListLoading />
        )
    }
  }

  return (
    <>
      <AddAudit isOpen={showAddaudit} onClose={handleCloseAudit} />
      <div
        className='d-flex justify-content-center align-items-center text-center'
        style={{height: '60%'}}
      >
        {renderContent()}
      </div>
    </>
  )
}

export default EmptyState
